import { Brain, ArrowDown } from "lucide-react";
import { Button } from "./ui/button";
export function HeroSection() {
  const scrollToContent = () => {
    const content = document.getElementById("blog-content");
    if (content) {
      content.scrollIntoView({
        behavior: "smooth",
      });
    }
  };
  return (
    <section className="relative min-h-[50vh] sm:min-h-[60vh] flex items-center justify-center bg-gradient-to-br from-kopf-primary via-kopf-primary/90 to-kopf-secondary/30 text-white overflow-hidden">
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS1vcGFjaXR5PSIwLjA1IiBzdHJva2Utd2lkdGg9IjEiLz48L3BhdHRlcm4+PC9kZWZzPjxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9InVybCgjZ3JpZCkiLz48L3N2Zz4=')] opacity-40"></div>

      <div className="container mx-auto px-4 py-12 sm:py-20 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <div className="mb-6 inline-flex items-center justify-center w-16 h-16 sm:w-24 sm:h-24 rounded-full bg-kopf-accent/20 backdrop-blur-sm animate-pulse">
            <Brain className="w-8 h-8 sm:w-12 sm:h-12 text-kopf-accent" />
          </div>

          <h1 className="text-3xl sm:text-4xl md:text-6xl font-bold mb-6 leading-tight">
            Sua Clareza Mental
            <br />
            Começa Aqui
          </h1>

          <p className="text-base sm:text-xl md:text-2xl text-white/90 mb-8 leading-relaxed max-w-2xl mx-auto">
            Artigos fundamentados para transformar sua jornada de bem-estar mental
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
            <Button
              size="lg"
              onClick={scrollToContent}
              className="bg-kopf-accent text-kopf-primary hover:bg-kopf-accent/90 font-semibold text-lg px-8"
            >
              Explorar Artigos
            </Button>
          </div>
        </div>
      </div>

      <button
        onClick={scrollToContent}
        className="absolute bottom-8 inset-x-0 mx-auto w-fit animate-bounce cursor-pointer bg-transparent border-none"
        aria-label="Scroll para o conteúdo"
      >
        <ArrowDown className="w-8 h-8 text-white/60" />
      </button>
    </section>
  );
}
